import React, { FunctionComponent, useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { signInWithPopup, User } from 'firebase/auth';
import logos from '../../media/logos-flag.png';
import heroWithAnimals from '../../media/illustration-hero-with-animals.png';
import logoBig from '../../media/logo-big.png';
import loginMessage from '../../media/login-message.png';
import { auth, googleAuthProvider } from '../../../services/firebase';
import GameContext from '../../context/GameContext';
import Information from '../../components/common/Information';

interface LoginProps {}

const Login: FunctionComponent<LoginProps> = () => {
    const history = useHistory();
    const { handleSetPlayerName, handleMainSound } = useContext(GameContext);

    const [showLoginButton, setShowLoginButton] = useState(false);

    const handleLoginSuccess = (user: User) => {
        if (user?.displayName) {
            handleSetPlayerName(user.displayName.replace(' ', ''));
        }

        history.push(`${process.env.PUBLIC_URL}/lobby`);
    };

    const handleLogin = async () => {
        try {
            const result = await signInWithPopup(auth, googleAuthProvider);

            //const credential = GoogleAuthProvider.credentialFromResult(result);
            //const token = credential?.accessToken;
            const user = result.user;

            handleLoginSuccess(user);
        } catch (error) {
            /*
            const errorCode = error.code;
            const errorMessage = error.message;
            const email = error.email;
            const credential = GoogleAuthProvider.credentialFromError(error);
*/
            console.log(error);
            history.push(`${process.env.PUBLIC_URL}/lobby`);
        }
    };

    useEffect(() => {
        handleMainSound('play-login-intro');

        setTimeout(() => {
            setShowLoginButton(true);
        }, 16000);

        return () => handleMainSound('stop-login-intro');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="page-container page-login animate__animated animate__fadeIn">
                {showLoginButton && (
                    <>
                        <div className="outer">
                            <div className="box"></div>
                        </div>
                        <div className="outer outer2">
                            <div className="box box2"></div>
                        </div>
                    </>
                )}
                <img
                    src={logos}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <img
                    src={heroWithAnimals}
                    className="illustration-hero-with-animals animate__animated animate__slideInUp"
                    alt="Héroe"
                />
                <div className="login-container">
                    <div className="login-logo-big">
                        <img
                            src={logoBig}
                            className="animate__animated animate__pulse animate__infinite"
                            alt="Héroes de la Cuenca"
                            width="100%"
                        />
                    </div>
                    {showLoginButton && (
                        <div className="login-message-button animate__animated animate__zoomInUp">
                            <img src={loginMessage} alt="¡Bienvenido/a!" width="100%" onClick={handleLogin} />
                            <p className="privacy-text">
                                Al iniciar sesión autorizo de manera voluntaria, previa, informada e inequívoca al
                                Proyecto Vivamos la Cuenca, para el tratamiento de los datos personales recolectados por
                                cualquier medio, ya sea virtual, personal, telefónico u otro, referentes a mi
                                información personal, la cual declaró la he suministrado de forma voluntaria y es
                                completa, confiable, exacta y verídica; de acuerdo a la ley 1581 de 2012 por la cual se
                                dictan disposiciones generales para la protección de datos personales.
                            </p>
                        </div>
                    )}
                </div>
            </div>
            <Information helpText='Haz clic en el botón de "Ingresar" para iniciar sesión con tu cuenta de Google. En caso de no tener una cuenta o si tienes problemas para iniciar sesión con la misma; podrás continuar con un nombre de avatar aleatorio. Ej. "Héroe1234"' />
        </>
    );
};

export default Login;
